var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"metodist-video",attrs:{"autoplay":"","playsinline":"","src":_vm.metodistVideo},on:{"ended":_vm.handleVideoEnd}})}
var staticRenderFns = []

export { render, staticRenderFns }